<template>
    <el-dialog :visible.sync="uploadVisible" title="导入发票信息" :close-on-click-modal="false" :close-on-press-escape="false">
        <el-upload
                name="file"
                :action="url"
                :headers="importHeaders"
                :data="uploadData"
                :file-list="fileList"
                drag
                :before-upload="beforeUploadHandle"
                :on-success="successHandle"
                class="text-center">
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">上传文件</div>
            <div class="el-upload__tip" slot="tip">只支持xls、xlsx格式文件！</div>
        </el-upload>
    </el-dialog>
</template>

<script>
    import config from "@/common/config";
    export default {
        name: "claim-upload",
        data () {
            return {
                uploadVisible: false,
                url: '',
                importHeaders:{
                    Authorization: sessionStorage.getItem('accessToken')
                },//上传请求头
                uploadData: {
                    currentUserId: sessionStorage.getItem('currentUserId'),
                    currentUserName: sessionStorage.getItem('name'),
                },
                fileList: []
            }
        },
        methods: {
            init () {
                this.uploadVisible = true
                this.url = config.baseUrl+'/finance-web/inputBill/claim/import';
                this.fileList = []
            },
            // 上传之前
            beforeUploadHandle (file) {
                if (!/.+\.(xlsx|xls|csv)$/.test(file.name)) {
                    this.$message.error('只支持xls、xlsx格式文件！')
                    return false
                }
            },
            // 上传成功
            successHandle (res, file, fileList) {
                if (res.code !== 10000000) {
                    return this.$message.error(res.msg)
                }
                this.$message({
                    message: '上传成功',
                    type: 'success',
                    duration: 500,
                    onClose: () => {
                        this.uploadVisible = false
                        this.$emit('refreshDataList')
                    }
                })
            }
        }
    }
</script>

<style scoped>
    /deep/.text-center{
        text-align: center!important;
    }
</style>
